export default __webpack_public_path__ + "static/media/study-icon.5735b9f5.svg";